import React, { useEffect } from 'react';
import { isBlank } from 'utils/helperMethods';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import Seo from 'sharedComponents/Seo';
import { createBidRequestEvent } from 'utils/gtmHelper';
import Loader from 'sharedComponents/Loader';

import MortgageSurveyPresenter from 'presenters/MortgageSurveyPresenter';

import useApp from 'reducers/hooks/useApp';
import useFirebaseChat from 'reducers/hooks/firebase/useChat';
import useChats from 'reducers/hooks/useChats';
import useBidRequests from 'reducers/hooks/buyer/loanOfficers/useBidRequests';
import useMortgageSurvey from 'reducers/hooks/useMortgageSurvey';

import LoanOfficerPresenter from 'presenters/LoanOfficerPresenter';
import { appRoutes } from 'routes';

import Survey from './components/Survey';
import BuyerRegistration from './components/BuyerRegistration';

import useStyles from './useStyles';

const SurveyPage = props => {
  const classes = useStyles();
  const history = useHistory();
  const { location, loanOfficer } = props;
  const { loadChats } = useChats();
  const { loadCurrentUser } = useApp();
  const { t } = useTranslation();

  useEffect(() => {
    if (isBlank(location) || isBlank(loanOfficer)) {
      history.push(appRoutes.loanOfficerSearchSurveyRootPath());
    }
  }, []);

  const { createBidRequest, isBidRequestCreating } = useBidRequests();
  const {
    surveyValues,
    discardSurveyValues,
    surveyPassed,
    setSelectedMortageSurveyFlow,
    selectedMortgageSurveyFlow,
    setInitialSurveyValues,
  } = useMortgageSurvey();
  const { setNeedToSelectChat } = useFirebaseChat();

  const handleCreateRequest = async () => {
    createBidRequestEvent();
    discardSurveyValues();

    const bidRequestParams = {
      bidRequest: {
        ...MortgageSurveyPresenter.buildBidRequestAtrributes(surveyValues),
        stateCode: location.state,
        city: location.city,
      },
      loanOfficersIds: [loanOfficer.id],
    };

    await createBidRequest(bidRequestParams);
    await loadCurrentUser();
    history.push(appRoutes.messagesPath());
    loadChats();
    setNeedToSelectChat(true);
  };

  if (isBidRequestCreating) {
    return <Loader fullFill />;
  }

  if (surveyPassed) return <BuyerRegistration onFinish={handleCreateRequest} />;

  return (
    <Box width="100%" height="100%" display="flex" flexDirection="column" alignItems="center">
      <Seo title={t('meta.NonAuthSurveyPage.title')} />
      <Box className={classes.paper}>
        <Box className={classes.survey}>
          <Survey
            onSelectFlow={setSelectedMortageSurveyFlow}
            selectedFlow={selectedMortgageSurveyFlow}
            surveyValues={surveyValues}
            setInitialSurveyValues={setInitialSurveyValues}
            loanOfficer={loanOfficer}
          />
        </Box>
      </Box>
    </Box>
  );
};

SurveyPage.propTypes = {
  location: PropTypes.shape(),
  loanOfficer: LoanOfficerPresenter.shape(),
};

SurveyPage.defaultProps = {
  location: {},
  loanOfficer: {},
};

export default SurveyPage;



// WEBPACK FOOTER //
// ./src/components/BuyerLoanOfficerSearchSurvey/components/SurveyPage/SurveyPage.js